import { UseQueryOptions } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { ApiResponse, Vendor } from "@/lib/types";
import { useQuery } from "@tanstack/react-query";

export const useGetVendors = (
  options?: Omit<UseQueryOptions<ApiResponse<Vendor[]>>, "queryKey" | "queryFn">
) => {
  return useQuery<ApiResponse<Vendor[]>>({
    queryKey: ["vendors"],
    queryFn: async () => {
      const response = await api.get("/vendors");
      return response.data;
    },
    ...options,
  });
};

export const useGetVendorById = (
  vendorId?: string,
  options?: Omit<UseQueryOptions<ApiResponse<Vendor>>, "queryKey" | "queryFn">
) => {
  return useQuery<ApiResponse<Vendor>>({
    queryKey: ["vendor-detail", vendorId],
    queryFn: async () => {
      const response = await api.get(`/vendors/${vendorId}`);
      return response.data;
    },
    enabled: !!vendorId,
    ...options,
  });
};

export const useGetVendorByOrganizationId = (
  organizationId: string,
  options?: Omit<UseQueryOptions<ApiResponse<Vendor[]>>, "queryKey" | "queryFn">
) => {
  return useQuery<ApiResponse<Vendor[]>>({
    queryKey: ["vendor-detail", organizationId],
    queryFn: async () => {
      const response = await api.get(`/vendors/${organizationId}`);
      return response.data;
    },
    ...options,
  });
};
